import QueryString from "query-string";
import { all, call, put, select, takeEvery } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert, successAlert } from "../Alerts/actions";
import {
  addEnquiryFailure,
  addEnquiryNoteFailure,
  //
  addEnquiryNoteSuccess,
  addEnquiryReminderFailure,
  //
  addEnquiryReminderSuccess,
  //
  addEnquirySuccess,
  deleteEnquiryFailure,
  deleteEnquiryNoteFailure,
  //
  deleteEnquiryNoteSuccess,
  deleteEnquiryReminderNoteFailure,
  //
  deleteEnquiryReminderNoteSuccess,
  //
  deleteEnquirySuccess,
  editEnquiryFailure,
  //
  editEnquirySuccess,
  exportEnquiryFailure,
  //
  exportEnquirySuccess,
  fetchEnquiries as fetchEnquiriesAction,
  fetchEnquiriesFailure,
  //
  fetchEnquiriesNotes,
  fetchEnquiriesNotesFailure,
  fetchEnquiriesNotesSuccess,
  //
  fetchEnquiriesReminders,
  fetchEnquiriesRemindersFailure,
  fetchEnquiriesRemindersSuccess,
  fetchEnquiriesSuccess,
  //
  getViewData as getViewDataAction,
  getViewDataFailure,
  getViewDataSuccess,
  importEnquiryFailure,
  //
  importEnquirySuccess,
} from "./actions";
import {
  ADD_ENQUIRY,
  ADD_ENQUIRY_NOTE,
  ADD_ENQUIRY_REMINDER,
  DELETE_ENQUIRY,
  DELETE_ENQUIRY_NOTE,
  DELETE_ENQUIRY_REMINDER_NOTE,
  EDIT_ENQUIRY,
  EXPORT_ENQUIRY,
  FETCH_ENQUIRIES,
  FETCH_ENQUIRIES_NOTES,
  FETCH_ENQUIRIES_REMINDERS,
  GET_VIEW_DATA,
  IMPORT_ENQUIRY,
} from "./constants";

export function* fetchEnquiriesSaga({ payload = { cancelToken: null } }) {
  const token = yield select((state) => state?.AuthReducer?.token);

  let query = payload ? QueryString.stringify(payload?.data) : "";
  try {
    const { data } = yield call(api(token).get, `/api/enquiries?${query}`);
    yield put(fetchEnquiriesSuccess(data));
  } catch (e) {
    yield put(fetchEnquiriesFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching enquiries!"));
  }
}

export function* getViewDataSaga({ payload = { cancelToken: null } }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(api(token).get, `/api/enquiries/${payload}`);
    yield put(getViewDataSuccess(data));
  } catch (e) {
    yield put(getViewDataFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching data!"));
  }
}

export function* addEnquirySaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/enquiries/add`,
      payload.data
    );
    if (data) {
      yield put(successAlert("Enquiry added successfully!"));
      yield put(addEnquirySuccess());
      if (payload?.history) {
        payload.history.push("/d/enquiries");
      }
    }
  } catch (e) {
    yield put(addEnquiryFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* editEnquirySaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/enquiries/edit/${payload.id}`,
      payload.data
    );
    if (data) {
      yield put(successAlert("Enquiry updated successfully!"));
      yield put(editEnquirySuccess());
      yield put(getViewDataAction(payload.id));
    }
  } catch (e) {
    yield put(editEnquiryFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* deleteEnquirySaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(api(token).delete, `/api/enquiries/${payload}`);
    if (data) {
      yield put(successAlert("Enquiry deleted successfully!"));
      yield put(deleteEnquirySuccess());
      yield put(fetchEnquiriesAction());
    }
  } catch (e) {
    yield put(deleteEnquiryFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* deleteEnquiryNoteSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(api(token).post, `/api/enquiries-notes`, payload);
    if (data) {
      yield put(successAlert("Note deleted successfully!"));
      yield put(deleteEnquiryNoteSuccess());
      yield put(getViewDataAction(payload.enquiry_id));
    }
  } catch (e) {
    yield put(deleteEnquiryNoteFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* deleteEnquiryReminderNoteSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/delete-enquiries-reminder`,
      payload
    );
    if (data) {
      yield put(successAlert("Reminder Note deleted successfully!"));
      yield put(deleteEnquiryReminderNoteSuccess());
      yield put(getViewDataAction(payload.enquiry_id));
    }
  } catch (e) {
    yield put(deleteEnquiryReminderNoteFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* addEnquiryNoteSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/enquiries-notes/add`,
      payload.data
    );
    if (data) {
      yield put(successAlert("Note added successfully!"));
      yield put(addEnquiryNoteSuccess());
      yield put(getViewDataAction(payload.data.enquiry_id));
      yield put(
        fetchEnquiriesNotes({ all: true, enquiry_id: payload.data.enquiry_id })
      );
    }
  } catch (e) {
    yield put(addEnquiryNoteFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* fetchEnquiriesNotesSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);

  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/enquiries-notes?${query}`
    );
    yield put(fetchEnquiriesNotesSuccess(data));
  } catch (e) {
    yield put(fetchEnquiriesNotesFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching notes!"));
  }
}

export function* addEnquiryReminderSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/enquiries-reminder/add`,
      payload.data
    );
    if (data) {
      yield put(successAlert("Reminder added successfully!"));
      yield put(addEnquiryReminderSuccess());
      yield put(getViewDataAction(payload.data.enquiry_id));
      yield put(
        fetchEnquiriesReminders({
          all: true,
          enquiry_id: payload.data.enquiry_id,
        })
      );
    }
  } catch (e) {
    yield put(addEnquiryReminderFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* fetchEnquiriesRemindersSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/enquiries-reminder?${query}`
    );
    yield put(fetchEnquiriesRemindersSuccess(data));
  } catch (e) {
    yield put(fetchEnquiriesRemindersFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching reminders!"));
  }
}

export function* exportEnquirySaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(api(token).post, `/api/enquiries-export`, payload);
    if (data) {
      yield put(successAlert("Enquiry exported successfully!"));
      yield put(exportEnquirySuccess());
      if (payload?.history) {
        payload.history.push("/d/enquiries");
      }
    }
  } catch (e) {
    yield put(exportEnquiryFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* importEnquirySaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(api(token).post, `/api/enquiries-import`, payload);
    if (data) {
      yield put(successAlert("Enquiry import successfully!"));
      yield put(importEnquirySuccess());
      if (payload?.history) {
        payload.history.push("/d/enquiries");
      }
    }
  } catch (e) {
    yield put(importEnquiryFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* fetchEnquiriesFlow() {
  yield takeEvery(FETCH_ENQUIRIES, fetchEnquiriesSaga);
}
export function* getViewDataFlow() {
  yield takeEvery(GET_VIEW_DATA, getViewDataSaga);
}
export function* addEnquiryFlow() {
  yield takeEvery(ADD_ENQUIRY, addEnquirySaga);
}
export function* editEnquiryFlow() {
  yield takeEvery(EDIT_ENQUIRY, editEnquirySaga);
}
export function* deleteEnquiryFlow() {
  yield takeEvery(DELETE_ENQUIRY, deleteEnquirySaga);
}
export function* deleteEnquiryNoteFlow() {
  yield takeEvery(DELETE_ENQUIRY_NOTE, deleteEnquiryNoteSaga);
}
export function* deleteEnquiryReminderNoteFlow() {
  yield takeEvery(DELETE_ENQUIRY_REMINDER_NOTE, deleteEnquiryReminderNoteSaga);
}
export function* addEnquiryNoteFlow() {
  yield takeEvery(ADD_ENQUIRY_NOTE, addEnquiryNoteSaga);
}
export function* fetchEnquiriesNotesFlow() {
  yield takeEvery(FETCH_ENQUIRIES_NOTES, fetchEnquiriesNotesSaga);
}
export function* addEnquiryReminderFlow() {
  yield takeEvery(ADD_ENQUIRY_REMINDER, addEnquiryReminderSaga);
}
export function* fetchEnquiriesRemindersFlow() {
  yield takeEvery(FETCH_ENQUIRIES_REMINDERS, fetchEnquiriesRemindersSaga);
}
export function* exportEnquiryFlow() {
  yield takeEvery(EXPORT_ENQUIRY, exportEnquirySaga);
}
export function* importEnquiryFlow() {
  yield takeEvery(IMPORT_ENQUIRY, importEnquirySaga);
}
export default function* EnquiriesSaga() {
  yield all([
    fetchEnquiriesFlow(),
    addEnquiryFlow(),
    editEnquiryFlow(),
    deleteEnquiryFlow(),
    getViewDataFlow(),
    deleteEnquiryNoteFlow(),
    deleteEnquiryReminderNoteFlow(),
    addEnquiryNoteFlow(),
    fetchEnquiriesNotesFlow(),
    addEnquiryReminderFlow(),
    fetchEnquiriesRemindersFlow(),
    exportEnquiryFlow(),
    importEnquiryFlow(),
  ]);
}
